<template>
  <HistoryPage />
</template>

<script setup lang="ts">
import HistoryPage from "shared-ui/pages/HistoryPage.vue";

definePage({
  meta: {
    requiresAuth: true,
    layout: "AppLayout",
  },
});
</script>
